import React from 'react'
import { theme, Text } from '../shared'
import { Base } from '../components'
import { StructuredData, PAGES } from '../utils'
import { BillboardWithImage } from '../shared/components/v2/BillboardWithImage/BillboardWithImage'
import {
  aboutHeroBillboardProps,
  aboutInsightsBillboardProps,
  aboutMissionBillboardProps,
  aboutMoveMoneyBillboardProps,
  aboutOurTeamBillboardProps,
  aboutOurHistoryTextBlockProps,
} from '../data/pages/about.data'
import { TextBlock } from '../shared/components/v2/TextBlock/TextBlock'

const fontStyle = {
  color: theme.colors.blackPrimary,
  fontFamily: theme.fonts.grtskExa,
  fontSize: '12px',
  lineHeight: '14px',
  fontWeight: 400,
  letterSpacing: '-0.16px',
  fontStyle: 'normal',
  marginBottom: '15px',
}

const About = (): JSX.Element => {
  const ABOUT = PAGES.ABOUT.MAIN
  return (
    <Base
      headKey={ABOUT.HEAD_KEY}
      title={ABOUT.TITLE}
      metaDescription={ABOUT.DESCRIPTION}
      breadcrumbs={ABOUT.BREADCRUMBS}
      customFooterBody={
        <>
          <Text
            tag={'p'}
            sx={{
              ...fontStyle,
            }}
          >
            {
              '¹NorthOne has a Monthly Account Fee. There are additional fees for sending and receiving domestic wires. See the Deposit Account Agreement for details.'
            }
          </Text>
          <Text
            tag={'p'}
            sx={{
              ...fontStyle,
            }}
          >
            {'²Additional ATM fees may be charged by 3rd party ATMs or ATM owner.'}
          </Text>
          <Text
            tag={'p'}
            sx={{
              ...fontStyle,
            }}
          >
            {
              '⁶Our Customer Care Team is here to help Monday to Friday, 8AM to 9PM ET, and Saturday to Sunday, 9AM to 6PM ET (excluding December 25th). Send us a message through the mobile app chat, our website, or email us at support@northone.com.'
            }
          </Text>
        </>
      }
    >
      <StructuredData schemaTypes={['AboutPage', 'Organization']} />
      <BillboardWithImage {...aboutHeroBillboardProps} />
      <BillboardWithImage {...aboutInsightsBillboardProps} />
      <BillboardWithImage {...aboutMoveMoneyBillboardProps} />
      <TextBlock {...aboutOurHistoryTextBlockProps} />
      <BillboardWithImage {...aboutMissionBillboardProps} />
      <BillboardWithImage {...aboutOurTeamBillboardProps} />
    </Base>
  )
}

export default About
